import i18n from '@/plugins/i18n';
import numeral from 'numeral';
import { convertTimezone } from "@/common/tenancy/convertTimezone";
function formatNumber(value) {
    return numeral(value).format("0,0");
}

function formatNumberDigit(value) {
    return numeral(value).format("0,0.00");
}


export default [
    {
        name: "ch",
        title: i18n.t('Ch.'),
        width: "50px",
        titleClass: "px-2",
        dataClass: "vertical-align-top text-left px-2"
    },
    {
        id: 'order_number',
        name: 'order_number',
        title: i18n.t('Order No.'),
        visible: true,
        width: "110px",
        togglable: false,
        titleClass: "px-2",
        dataClass: "vertical-align-top text-left px-2"
    },
    {
        name: 'reserved_quantity',
        title: i18n.t('_Inventory.Reserved'),
        width: "50px",
        titleClass: "px-2",
        dataClass: "vertical-align-top text-left px-2",
        formatter: (data) => {
            return formatNumber(data);
        }
    },
    {
        id: 'fullname',
        title: i18n.t('Customer Name'),
        visible: true,
        width: "150px",
        name: 'fullname',
        togglable: false,
        titleClass: "px-2",
        dataClass: "vertical-align-top text-left px-2"
    },
    {
        id: 'created_date',
        visible: true,
        name: 'created_date',
        sortField: 'created_date',
        title: i18n.t('Order Date'),
        width: "100px",
        // togglable: true,
        titleClass: "pl-2 pr-0",
        dataClass: "vertical-align-top text-left pl-2 pr-0",
        formatter: (data) => {
            return convertTimezone.utcToLocal(data);
        }
    },
    // {
    //     id: 'created_by',
    //     visible: true,
    //     name: 'created_by',
    //     title: i18n.t('Create By'),
    //     width: "200px",
    //     dataClass: "vertical-align-top text-left",
    //     formatter: (data) => {
    //         if(data){
    //             return i18n.t(data);
    //         }
    //         return '-';
    //     }
    // },
];


// WEBPACK FOOTER //
// ./src/components/tenancy/admin/stock/assets/FieldsItemReserve.js